export const noIndexCategoyIds = [
  '7520',
  '7519',
  '7521',
  '6112',
  '7577',
  '7522',
  '6782',
  '5179',
];

export const IndexCategoyIds = [7504];
